import { PropsWithChildren } from 'react';
import { SnackbarProvider as SnackbarProviderNotistack } from 'notistack';
import { Snackbar } from '@issuemanager/apps/client/components';

function SnackbarProvider({ children }: PropsWithChildren) {
  return (
    <SnackbarProviderNotistack
      Components={{
        success: Snackbar,
        error: Snackbar,
        info: Snackbar,
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      // default autoHideDuration is 5000
    >
      {children}
    </SnackbarProviderNotistack>
  );
}

export default SnackbarProvider;
